import { formatINR } from '../data/common';
import { DocSection } from './DocumentShell';

const payLabel = { upi: 'UPI', card: 'Credit Card', international: 'International Card', debit: 'Debit Card', netbanking: 'Net Banking', nb: 'Net Banking', emi: 'No-cost EMI' };

/** Fare breakdown in INR, the currency actually charged, whatever display currency the visitor chose. */
export default function PaymentSummary({ booking }) {
  const { fare } = booking;
  return (
    <DocSection title="Payment summary" className="doc-pay">
      <table className="doc-table doc-amounts">
        <tbody>
          {fare.lines.map(([label, amount]) => (
            <tr key={label}><td>{label}</td><td>{amount < 0 ? `−${formatINR(-amount)}` : formatINR(amount)}</td></tr>
          ))}
          {fare.convenienceFee > 0 && <tr><td>Convenience fee</td><td>{formatINR(fare.convenienceFee)}</td></tr>}
          {fare.discount > 0 && <tr><td>Promo {fare.coupon}</td><td>−{formatINR(fare.discount)}</td></tr>}
          <tr className="doc-total"><td>Total paid</td><td>{formatINR(fare.total)}</td></tr>
        </tbody>
      </table>
      <p className="doc-small">
        Paid by {payLabel[booking.payment] || 'online payment'}
        {booking.status === 'cancelled' && booking.refund ? ` · Refund ${formatINR(booking.refund.amount || 0)}${booking.refund.note ? ` (${booking.refund.note})` : ''}` : ''}
      </p>
    </DocSection>
  );
}
